import { useState, useEffect } from 'react';

/**
 * Array of funny loading messages themed around chat/yearbook context
 */
const FUNNY_MESSAGES = [
  "Reading all 47 times someone said 'lol'...",
  "Counting inside jokes we'll never understand...",
  "Searching for that one message everyone forgot...",
  "Decoding mysterious voice notes...",
  "Analyzing who really starts the drama...",
  "Calculating who takes longest to reply...",
  "Finding the group chat's true MVP...",
  "Discovering who sends the most memes...",
  "Translating 'k' into actual emotions...",
  "Measuring friendship in emoji reactions...",
  "Identifying the midnight texters...",
  "Cataloging all the 'we should hang out!' that never happened...",
  "Counting unread messages that changed lives...",
  "Archiving legendary comebacks...",
  "Preserving the chaos for posterity...",
  "Locating the perfect screenshot moments...",
  "Remembering conversations you definitely forgot...",
  "Gathering evidence of your questionable opinions...",
];

/**
 * Custom hook that provides rotating funny loading messages
 * @param {number} intervalMs - Time between message changes (default: 3000ms)
 * @returns {string} Current funny loading message
 */
export function useFunnyLoadingText(intervalMs = 3000) {
  const [messageIndex, setMessageIndex] = useState(() => 
    Math.floor(Math.random() * FUNNY_MESSAGES.length)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % FUNNY_MESSAGES.length);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return FUNNY_MESSAGES[messageIndex];
}

export default useFunnyLoadingText;


